import React, { useCallback, useEffect, useState } from 'react';
import { Navigate, useParams } from "react-router-dom";

import { ArrowBack } from '@mui/icons-material';
import { Tooltip, Fab } from "@mui/material";
import { Chip } from "@mui/material";
import Grid from '@mui/material/Grid2';

import { 
  ModelBase,
} from "@models";
import { 
  SpellList, 
  Spell,
  SpellLimitation,
} from "@dndModels";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

import StringBox from "@components/input/strings/StringBox";
import ButtonBox from "@components/input/buttons/ButtonBox";
import LoadingBox from "@components/input/LoadingBox";

import SpellLimitInput from "@dndComponents/limitations/SpellLimitInput";
import ModelBaseDetails from "@dndComponents/ModelBaseDetails";
import CenteredMenu from "@components/input/menus/CenteredMenu";
import SelectSourceBookBox from '@dndComponents/select/SelectSourceBookBox';
import { SourceBookType } from '@dndModels/Types';
import CheckBox from '@components/input/CheckBox';

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function SpellListEdit() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [navigateTo, setNavigateTo] = useState<string | null>(null);
  const [obj, setObj] = useState<SpellList>(api.applyWorkingOn(new SpellList()));
  // const [parse_string, setParseString] = useState("");
  const [change_time, setChangeTime] = useState(0);
  const [mode, setMode] = useState("Main");
  const [spells, setSpells] = useState<Spell[]>([]);
  const [sl_sb_type, setSLSBType] = useState<SourceBookType | "">("");
  const [sl_sb_id, setSLSBId] = useState("");
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  const load = useCallback(async () => {
    setFetched(true);
    // debugger;
    setLoading(true);
    const res = await api.getSetOfObjects({ data_types: ["spell","spell_list"] });
    setSpells(res.spell as Spell[]);
    if (id && id !== "") {
      const spell_lists = res.spell_list as SpellList[];
      // for (const sl of spell_lists) {
      //   debugger;
      //   if (sl.isEmpty() && !sl.limit.isEmpty()) {
      //     // It's in the old way of doing things.
      //     if (sl.limit.isEmpty(["spell_ids"])) {
      //       // Go through all the spells.
      //       // Put them onto limits for all the sbs they're on.
      //       const spells = api.spells.filter(o => sl.limit.spell_ids.includes(o._id));
      //       const new_limit_hash: { [source_book_id: string]: SpellLimitation } = {};
      //       for (const spell of spells) {
      //         for (const sb_id of spell.source_book_ids) {
      //           if (!new_limit_hash[sb_id]) {
      //             new_limit_hash[sb_id] = new SpellLimitation();
      //           }
      //           new_limit_hash[sb_id].spell_ids.push(spell._id);
      //         }
      //       }
      //       sl.limit_hash = new_limit_hash;
      //       await api.upsertObject("spell_list", sl);
      //     } else {
      //       // Don't want to forget about this. Will want to manage it individually.
      //       debugger;
      //     }
      //   }
      // }
      const new_obj = spell_lists.find(o => o._id === id);
      if (new_obj) {
        setObj(new_obj);
      }
    } 
    setLoading(false);
  }, []);

  useEffect(() => {
    if (!fetched) {
      load();
    }
  }, [fetched, load]);
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  // const parse = () => {
  //   const pieces = parse_string.split("\n");
  //   console.log(parse_string);
  //   console.log(pieces);
  //   const new_obj = obj;
  //   console.log(new_obj);
  //   const limit = new_obj.getLimit(sl_sb_id);
  //   for (const piece of pieces) {
  //     let spell_name = piece;
  //     spell_name = common_util.replaceAll(spell_name, "’", "'");
  //     spell_name = common_util.replaceAll(spell_name, "*","");
  //     spell_name = common_util.replaceAll(spell_name, "(ritual)","");
  //     spell_name = spell_name.trim().toLowerCase();
  //     const spell_finder = spells.filter(o => 
  //       o.name.trim().toLowerCase() === spell_name && o.is_true_dominant);
  //     if (spell_finder.length === 1) {
  //       const spell_id = spell_finder[0]._id;
  //       if (!limit.spell_ids.includes(spell_id)){
  //         limit.spell_ids.push(spell_id);
  //       }
  //     } else if (spell_finder.length > 1) {
  //       console.error("Multiple Spells found");
  //       console.error(spell_name);
  //       console.error(spell_finder);
  //     } else if (spell_name.includes("Cantrip") || spell_name.includes("evel") || spell_name.length === 0) {
  //       // Ignore these lines
  //     } else {
  //       console.error("Unable to find spell when parsing list");
  //       console.log(piece);
  //       debugger;
  //     }
  //   }
  //   console.log(limit.spell_ids);
  //   new_obj.setLimit(sl_sb_id, limit.clone());
  //   setObj(new_obj);
  // }

  const getSourceBookName = (id: string): string => {
    const sb = api.source_books.find(o => o._id === id);
    return sb ? sb.name : "Source Book Not Found";
  };

  const removeLimitEntry = (sb_id: string) => {
    const new_obj = obj;
    delete new_obj.limit_hash[sb_id];
    new_obj.major_limits = new_obj.major_limits.filter(o => o !== sb_id);
    if (sl_sb_id === sb_id) {
      setSLSBId("");
      setSLSBType("");
    }
    setObj(new_obj);
    setChangeTime(common_util.get_time_number());
    setReloading(true);
  };

  const renderLimits = () => {
    const limitKeys = Object.keys(obj.limit_hash);

    return (
      <>
        {limitKeys.length > 0 && (
          <Grid size={12}>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", padding: "4px 0" }}>
              {limitKeys.map(key => (
                <Chip
                  key={key}
                  label={getSourceBookName(key)}
                  color={sl_sb_id === key ? "primary" : "default"}
                  variant={sl_sb_id === key ? "filled" : "outlined"}
                  onClick={() => {
                    const sb = api.source_books.find(o => o._id === key);
                    setSLSBType(sb ? sb.source_book_type : "");
                    setSLSBId(key);
                    setReloading(true);
                  }}
                  onDelete={() => removeLimitEntry(key)}
                />
              ))}
            </div>
          </Grid>
        )}
        <Grid size={12}>
          <SelectSourceBookBox
            name="Add / Switch Source Book"
            type={sl_sb_type}
            id={sl_sb_id}
            disabled={disabled}
            onChange={(type, id) => {
              setSLSBType(type);
              setSLSBId(id);
              setReloading(true);
            }}
          />
        </Grid>
        {/* <Grid size={10}>
          <StringBox
            name="Parse String"
            value={`${parse_string}`}
            multiline
            onBlur={(changed: string) => {
              while (changed.includes(" No ")) {
                changed = changed.replace(" No ", " No\n");
              }
              while (changed.includes(" Yes ")) {
                changed = changed.replace(" Yes ", " Yes\n");
              }
              while (changed.includes("'")) {
                changed = changed.replace("'", "'");
              }
              setParseString(changed);
            }}
          />
        </Grid>
        <Grid size={2}>
          <ButtonBox
            name="Parse"
            disabled={disabled || sl_sb_id === ""}
            onClick={parse}
          />
        </Grid> */}
        {renderLimit()}
      </>
    );
  };

  const renderLimit = () => {
    if (sl_sb_id !== "" && !reloading) {
      const limit = obj.getLimit(sl_sb_id);
      return (
        <>
          <Grid size={12}>
            <CheckBox
              name="Major Limit"
              disabled={disabled}
              value={obj.major_limits.includes(sl_sb_id)}
              onChange={(changed) => {
                const new_obj = obj;
                if (changed) {
                  new_obj.major_limits.push(sl_sb_id);
                } else {
                  new_obj.major_limits = new_obj.major_limits.filter(o => o !== sl_sb_id);
                }
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
              }}
            />
          </Grid>
          <Grid size={12}>
            <SpellLimitInput 
              obj={limit} 
              block_spell_lists={[obj._id]}
              disabled={disabled}
              onChange={(changed: SpellLimitation) => {
                const new_obj = obj;
                new_obj.setLimit(sl_sb_id, changed.clone());
                setObj(new_obj);
                setChangeTime(common_util.get_time_number());
              }}
            />
          </Grid>
        </>
      );
    }
    return null;
  }
  
  const height = window.innerHeight - 64;
  if (!fetched || loading) {
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  } else if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else {
    return (
      <Grid container spacing={0} direction="row">
        <Grid size={3}>
          <Tooltip title={`Back to Spell Lists`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                setNavigateTo(`/dandd/${obj.data_type}`);
              }}>
              <ArrowBack/>
            </Fab>
          </Tooltip>
        </Grid>
        <Grid size={12}>
          <span className="header">
            { obj._id === "" ? `Create Spell List` : `Edit ${obj.name}` }
          </span>
        </Grid>
        <Grid size={12}>
          <StringBox 
            value={obj.name} 
            message={obj.name.length > 0 ? "" : "Name Invalid"} 
            name="Name"
            disabled={disabled}
            onBlur={(value: string) => {
              const new_obj = obj;
              new_obj.name = value;
              setObj(new_obj);
              setChangeTime(common_util.get_time_number());
            }}
          />
        </Grid>
        <Grid size={12}>
          <CenteredMenu
            options={["Main","Limits"]}
            selected={mode}
            onSelect={setMode}
          />
        </Grid>
        { mode === "Main" ? 
          <>
            <Grid size={12}>
              <ModelBaseDetails
                obj={obj}
                change_time={change_time}
                disabled={disabled}
                onChange={(changed: ModelBase) => {
                  const new_obj = obj;
                  if (changed instanceof SpellList) {
                    new_obj.copy(changed);
                  }
                  setObj(new_obj);
                  setChangeTime(common_util.get_time_number());
                }}
              />
            </Grid>
          </>
        : renderLimits()
        }
      </Grid>
    );
  }
}
